import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts'

interface RevenueChartProps {
    data: Array<{
        month: string
        revenue: number
    }>
}

export default function RevenueChart({ data }: RevenueChartProps) {
    if (!data || data.length === 0) return null

    return (
        <div className="bg-white p-10 rounded-[3.5rem] border border-[#001c28]/5 shadow-2xl shadow-[#001c28]/5">
            <div className="flex items-center gap-3 mb-8">
                <div className="p-3 rounded-2xl bg-[#001c28]/5">
                    <svg className="w-6 h-6 text-[#001c28]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                </div>
                <h3 className="text-xl font-black text-[#001c28] uppercase italic tracking-tighter">Receita Mensal</h3>
            </div>

            <div className="h-80 w-full">
                <ResponsiveContainer width="100%" height="100%">
                    <LineChart data={data} margin={{ top: 20, right: 30, left: 10, bottom: 20 }}>
                        <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#f0f0f0" />
                        <XAxis
                            dataKey="month"
                            axisLine={false}
                            tickLine={false}
                            tick={{ fontSize: 11, fontWeight: 'bold', fill: '#6b7280' }}
                            angle={0}
                            textAnchor="middle"
                        />
                        <YAxis
                            axisLine={false}
                            tickLine={false}
                            tick={{ fontSize: 11, fontWeight: 'bold', fill: '#6b7280' }}
                            tickFormatter={(value: any) => `R$ ${value.toFixed(0)}`}
                        />
                        <Tooltip
                            contentStyle={{
                                borderRadius: '16px',
                                border: 'none',
                                boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
                                fontSize: '12px',
                                fontWeight: '700',
                                padding: '12px'
                            }}
                            formatter={(value: any) => [`R$ ${value.toFixed(2)}`, 'Receita']}
                            cursor={{ stroke: '#d4a94d', strokeWidth: 2 }}
                        />
                        <Line
                            type="monotone"
                            dataKey="revenue"
                            stroke="#d4a94d"
                            strokeWidth={3}
                            dot={{ fill: '#d4a94d', r: 6 }}
                            activeDot={{ r: 8 }}
                        />
                    </LineChart>
                </ResponsiveContainer>
            </div>
        </div>
    )
}
